import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AuthService } from '#root/core/auth/auth.service';

@NgModule({ imports: [], providers: [
        AuthService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AuthModule {
}
